import { useNavigate } from 'react-router-dom';

export default function CTASection() {
  const navigate = useNavigate();

  return (
    <section className="relative w-full py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dark%20digital%20art%20with%20neon%20pink%20and%20cyan%20light%20streaks%20flowing%20diagonally%20across%20a%20black%20void%2C%20futuristic%20data%20stream%20visualization%2C%20volumetric%20light%20rays%20cutting%20through%20dense%20fog%2C%20cyberpunk%20aesthetic%20with%20electric%20energy%2C%20cinematic%20composition%2C%20editorial%20style%20with%20deep%20contrast%20and%20atmospheric%20glow%20effects&width=1800&height=600&seq=cta-bg-2026-x5&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black/80"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-foreground-50 mb-4">
              还没加入吃瓜大军？
            </h2>
            <p className="text-sm md:text-base text-foreground-300 max-w-md leading-relaxed">
              每日更新最新爆料，网红翻车、明星八卦、反差视频一网打尽。免费无卡顿，立即体验全网最爽的吃瓜之旅。
            </p>
          </div>

          <button
            onClick={() => {
              const el = document.getElementById('daily-news');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-3 bg-foreground-50 text-background-50 px-6 py-3 rounded-full font-medium text-sm hover:bg-primary-500 hover:text-foreground-50 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <span className="w-7 h-7 rounded-full bg-background-50 flex items-center justify-center">
              <i className="ri-arrow-right-line text-foreground-50 text-sm"></i>
            </span>
          </button>
        </div>
      </div>
    </section>
  );
}